export default __webpack_public_path__ + "static/media/pp-bg-xl.fe6a0579.svg";